import { render, staticRenderFns } from "./ListaEstoque.vue?vue&type=template&id=1680f494&scoped=true&"
import script from "./ListaEstoque.vue?vue&type=script&lang=js&"
export * from "./ListaEstoque.vue?vue&type=script&lang=js&"
import style0 from "./ListaEstoque.vue?vue&type=style&index=0&id=1680f494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680f494",
  null
  
)

export default component.exports